import Dialog from "components/ui/Dialog/Dialog";
import Loader from "components/ui/Loader/Loader";
import Trans from "features/translation/components/Trans";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";
import { useGroupAccess } from "features/groups/hooks/useGroupAccess";
import PropTypes from "prop-types";
import { useState } from "react";
import Alert from "components/ui/Alert/Alert";

const GroupMemberLeaveDialog = ({ groupMemberId, isPrivate, onCompleted }) => {
  const { hideDialog } = useDialog();
  const { working, leaveGroup } = useGroupAccess();
  const [ error, setError ] = useState('');

  const onConfirm = async () => {
    setError(null);

    const response = await leaveGroup(groupMemberId);

    if (!response?.ok) {
      setError(`Er ging iets mis bij het verlaten van de groep, ververs de pagina en probeer het opnieuw.`);
      return;
    }

    hideDialog();
    onCompleted();
  }

  return (
    <Dialog title={ `Weet u zeker dat u de groep wilt verlaten?` }>
      { error && <Alert message={ error }/> }
      {
        working ? <Loader/> :
          <>
            <div className={ `dialog__row` }>
              <h3><Trans text={ `` }/></h3>
            </div>

            <div className={ `dialog__row` }>
              <Trans
                text={ `Als u deze groep verlaat, kunt u geen berichten meer plaatsen en ontvangen in de groep.` }/>
            </div>

            {
              isPrivate &&
              <div className={ `dialog__row` }>
                <Trans text={ `Ook kunt u de groepsberichten en ledenlijst van deze groep niet meer zien.` }/>
              </div>
            }

            <div className="dialog__buttons">
              <Button variant={ `ghost` } onClick={ () => hideDialog() }>Annuleren</Button>
              <Button variant={ `secondary` } onClick={ onConfirm }>Groep verlaten</Button>
            </div>
          </>
      }
    </Dialog>
  );
}

GroupMemberLeaveDialog.propTypes = {
  groupMemberId: PropTypes.number.isRequired,
  isPrivate: PropTypes.bool.isRequired,
  onCompleted: PropTypes.func.isRequired
}

export default GroupMemberLeaveDialog;
